import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const EPSIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="889px"
    height="577px"
    viewBox="0 0 889 577"
    enable-background="new 0 0 889 577"
    xmlSpace="preserve"
  >
    <g>
      <defs>
        <rect id="SVGID_1_" width="889" height="577" />
      </defs>
      <clipPath id="SVGID_2_">
        <use xlinkHref="#SVGID_1_" overflow="visible" />
      </clipPath>
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M663,295L663,295h-61.252c-6.813,0-12.355-5.428-12.355-12.223
		c0-6.795,5.543-12.777,12.355-12.777H695v-46h-93.252c-32.547,0-59.028,26.534-59.028,59s26.481,59,59.028,59h60.42
		c6.813,0,12.356,5.406,12.356,12.201S668.98,366,662.168,366H532.605c-11,21-21.695,39-43.408,48H663
		c32-0.461,58.176-27.542,58.176-59.721C721.176,322.102,695,295.461,663,295"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M428.197,224C376.283,224,334,266.535,334,318.8v2V516h47V414h47.099
		c51.915,0,94.049-43.101,94.049-95.366C522.147,266.369,480.113,224,428.197,224 M428.197,366H381v-47.366
		c0-26.468,21.073-48.002,47.197-48.002c26.125,0,47.377,21.534,47.377,48.002C475.574,345.103,454.322,366,428.197,366"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#C8036F"
        d="M185.203,414c-44.44,0-81.802-31.667-91.912-73.037
		c0,0-2.921-13.678-2.921-22.685s2.765-22.826,2.765-22.826c10.183-41.268,47.499-71.998,91.866-71.998
		c52.181,0,94.999,42.418,94.999,94.598V341H141.365c8.187,16,24.744,25,43.838,25h124.626L310,230.681
		c0-20.175-16.505-36.681-36.68-36.681H96.682C76.507,194,60,210.006,60,230.181v176.638C60,426.994,76.507,444,96.682,444h176.638
		c18.105,0,33.208-13,36.126-30H185.203z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#C8036F"
        d="M185,268.356c-19.02,0-35.561,11.644-43.781,26.644h87.564
		C220.563,280,204.023,268.356,185,268.356"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#C8036F"
        d="M265,136.559c0-43.111-35.828-78.059-80.023-78.059
		c-43.463,0-78.812,33.805-79.973,75.928c-0.019,0.178-0.004,0.351-0.004,0.534v23.458c0,2.806,2.285,5.58,5.161,5.58h29.441
		c2.876,0,5.398-2.774,5.398-5.58v-21.861c0-21.528,17.93-39.043,40-39.043s40,17.515,40,39.043v21.861
		c0,2.806,2.333,5.58,5.209,5.58h29.442c2.876,0,5.349-2.774,5.349-5.58V136.559z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M480.928,475.001l-4.256,24.098c-2.128,12.18-10.109,17.758-20.927,17.758
		c-9.162,0-16.256-5.972-14.187-17.738l4.255-24.117h6.563l-4.258,24.098c-1.301,7.511,2.069,11.787,8.454,11.787
		c6.562,0,12.178-3.903,13.536-11.768l4.257-24.117H480.928z M455.153,467.455c0,2.01,1.538,2.954,3.193,2.954
		c2.069,0,4.316-1.477,4.316-4.255c0-1.95-1.303-2.954-3.017-2.954C457.52,463.2,455.153,464.559,455.153,467.455 M469.342,467.396
		c0,2.068,1.596,3.013,3.311,3.013c1.832,0,4.257-1.477,4.257-4.195c0-1.949-1.421-3.014-3.016-3.014
		C471.766,463.2,469.342,464.559,469.342,467.396"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M496.787,475l-2.956,16.651c2.541-3.427,7.625-5.238,11.172-5.238
		c7.33,0,12.414,4.295,12.414,12.273c0,11.291-7.862,18.081-17.91,18.081c-3.902,0-7.214-1.45-9.223-5.114L489.161,516h-5.734
		l7.271-41H496.787z M492.177,503.102c-0.236,4.847,2.896,7.98,7.447,7.98c5.734,0,11.29-4.436,11.646-11.172
		c0.236-4.907-2.955-7.805-7.391-7.805C498.204,492.105,492.529,496.658,492.177,503.102"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M529.371,504c-0.237,4,2.896,7.266,8.217,7.266
		c2.956,0,6.856-1.155,8.984-3.165l3.311,3.826c-3.604,3.309-8.926,4.955-13.418,4.955c-8.393,0-13.301-5.026-13.301-12.712
		c0-10.227,8.039-17.848,18.324-17.848c9.4,0,14.721,5.678,11.528,17.678H529.371z M548.051,499c0.473-5-2.482-7.035-7.39-7.035
		c-4.433,0-8.511,2.035-10.286,7.035H548.051z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M569.283,487l-0.297,3.855c2.84-3.729,6.268-4.488,9.399-4.488
		c2.837,0,5.378,1.007,6.739,2.483l-3.664,5.321c-1.301-1.179-2.602-1.77-4.849-1.77c-4.197,0-8.334,2.517-9.28,7.896L564.555,516
		h-6.09l5.143-29H569.283z"
      />
      <polygon
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        points="614.455,487 617.528,509.934 628.642,487 635.439,487 620.188,516
		613.036,516 610.14,496.869 605.469,506.373 600.386,516 593.292,516 588.148,487 595.006,487 598.021,509.934 609.193,487 	"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M643.259,504c-0.237,4,2.896,7.266,8.217,7.266
		c2.956,0,6.856-1.155,8.983-3.165l3.312,3.826c-3.604,3.309-8.926,4.955-13.418,4.955c-8.394,0-13.301-5.026-13.301-12.712
		c0-10.227,8.039-17.848,18.325-17.848c9.399,0,14.72,5.678,11.527,17.678H643.259z M661.938,499c0.473-5-2.482-7.035-7.39-7.035
		c-4.432,0-8.511,2.035-10.286,7.035H661.938z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M683.585,487l-5.142,29h-6.09l5.144-29H683.585z M678.206,479.1
		c0,2.068,1.538,3.137,3.193,3.137c2.364,0,4.552-1.54,4.552-4.435c0-1.953-1.479-3.077-3.074-3.077
		C680.688,474.725,678.206,476.146,678.206,479.1"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M710.605,494.174c-1.893-2.128-4.314-2.719-7.211-2.719
		c-4.022,0-6.858,1.36-6.858,3.901c0,2.128,2.305,3.018,5.734,3.312c5.32,0.472,12.118,2.247,10.699,9.754
		c-1.004,5.438-6.443,8.63-14.011,8.63c-4.728,0-9.28-1.065-12.354-5.379l3.96-4.315c2.187,3.013,6.03,4.256,9.458,4.315
		c2.896,0,6.326-1.064,6.857-3.783c0.532-2.601-1.773-3.605-6.029-4.021c-4.966-0.473-10.403-2.303-10.403-7.802
		c0-7.271,7.86-9.813,13.773-9.813c4.491,0,7.803,1.004,10.522,3.901L710.605,494.174z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M729.824,487l-2.776,15.617c-0.887,4.967,1.36,8.398,6.442,8.398
		c4.788,0,8.867-3.967,9.693-8.813l2.66-15.202h6.089l-5.141,29h-5.498l0.413-4.202c-3.429,3.251-6.799,4.784-10.876,4.784
		c-7.153,0-11.409-5.128-9.873-13.933L723.736,487H729.824z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M778.665,516l2.778-15.522c0.886-5.025-0.826-8.354-6.384-8.354
		c-4.847,0-8.928,3.899-9.754,8.687L762.645,516h-6.088l5.145-29h5.555l-0.413,4.238c3.37-3.133,6.856-4.679,10.638-4.679
		c7.096,0,11.707,4.936,10.112,13.863L784.813,516H778.665z"
      />
      <path
        clip-path="url(#SVGID_2_)"
        fill="#71706F"
        d="M799.303,520c-0.413,4,2.66,5.618,7.806,5.618
		c4.493,0,9.341-2.509,10.464-8.892l0.885-4.98c-2.659,3.724-7.507,5.194-11.111,5.194c-7.45,0-12.651-4.436-12.651-12.478
		c0-11.466,8.511-18.089,18.146-18.089c4.081,0,7.746,1.938,9.047,5.248l1.006-4.622h5.91l-5.085,29.862
		c-1.89,11.056-10.107,14.486-17.614,14.486c-8.987,0-13.95-4.349-12.711-11.349H799.303z M801.018,503.28
		c0,4.963,3.252,7.979,7.925,7.979c12.588,0,15.959-19.33,3.366-19.33C806.338,491.93,801.018,496.361,801.018,503.28"
      />
      <g clip-path="url(#SVGID_2_)"></g>
    </g>
  </SvgIcon>
)

export default EPSIcon
